import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Check = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M5 13L9 17L19 7" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Check };